import { PerformanceDatapoint } from "owa-analytics";
import type { TraceErrorObject } from "owa-analytics-types";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import type { IUTEPlacesFeatureLatencyArgs, UTPlaceAdminRoles } from "@outlook/unified_telemetry";
import { type UTPageType, type UTPlacesFeatureAction, type UTPlacesFeatureName, type UTPlacesFeatureUIContext } from "@outlook/unified_telemetry";
import { PlacesMarkerTimeout } from "./constants";
import { actActionIfExecuting } from "./utils/actActionIfExecuting";
import { addCustomWaterfallIfExecuting } from "./utils/addCustomWaterfallIfExecuting";
import { createPlacesPerformanceMarker } from "./utils/createPlacesPerformanceMarker";

let PlacesManagementLoadE2E: PerformanceDatapoint | undefined = undefined;

/**
 * These strings are expensive to store in kusto. keeping it short.
 * This list is the source of truth.
 */
export const STEP_TO_WATERFALL_INDEX_MAP = {
    bl: 1, // bl = bundle loaded
    pc: 2, // pc = permission checked
    pcf: 3, // pcf = permission check failed
    bs: 4, // bs = banner shown
    blds: 5, // blds = buildings loaded
    pcfc: 6, // pcfc = permission check from cache
    nps: 7, // nps = no permission page shown
    bldsf: 8, // bldsf = building load failed
} as const;

let shouldRunLoadE2EStart = true;
export function PlacesManagementLoadE2EStart(): PerformanceDatapoint | undefined {
    if (shouldRunLoadE2EStart) {
        shouldRunLoadE2EStart = false;
        const mailboxInfo = getModuleContextMailboxInfo();
        const dp: PerformanceDatapoint = new PerformanceDatapoint("PlacesFeatureLatency", mailboxInfo, {
            timeout: PlacesMarkerTimeout,
        });
        dp.addCustomData({
            scenario: "PlacesManagementLoadE2E",
        });
        
        PlacesManagementLoadE2E = createPlacesPerformanceMarker(dp);
    }
    return PlacesManagementLoadE2E;
}

export function PlacesManagementLoadE2EComplete(loadSuccessful: boolean, reason?: string, errorSource?: string, errorObject?: TraceErrorObject, placeAdminRoles?: UTPlaceAdminRoles): void {
    const errorSourceObj = loadSuccessful
        ? {}
        : { errorSource: !!errorSource ? errorSource : "EmptyErrorSourcePleaseUpdate" };
    PlacesManagementLoadE2E?.addUnifiedTelemetryData({
        eventName: "PlacesFeatureLatency",
        data: {
            PageType: "SpaceManagement",
            FeatureName: "PageLoad",
            FeatureAction: "Load",
            FeatureUIContext: "PageBannerRegion",
            PlaceManagementData: {
                PlaceAdminRoles: placeAdminRoles,
            },
        } as IUTEPlacesFeatureLatencyArgs /** PerfProperties and PerfCustomWaterfall is handled in logUnifiedDatapoint & mergeEvents */,
    });
    
    actActionIfExecuting(PlacesManagementLoadE2E, {
        loadSuccessful_1: loadSuccessful,
        reason,
        ...errorSourceObj,
    }, loadSuccessful ? "end" : "endWithError", errorObject);
}

export function PlacesManagementLoadE2ECheckmark(checkpoint: keyof typeof STEP_TO_WATERFALL_INDEX_MAP): void {
    addCustomWaterfallIfExecuting(PlacesManagementLoadE2E, STEP_TO_WATERFALL_INDEX_MAP[checkpoint], checkpoint as string);
}
